import { Button, Stack, Typography } from "@mui/material";
import * as React from "react";
import Modal, { CommonModalProps } from "..";
import { cockpitService, jobBrokerService } from "../../../Core/Api/services";
import useCustomSnackbar from "../../../Utils/Hooks/useCustomSnackbar";
import { MakeOperationRequest } from "../../../Core/Api/Types/make-operation-request";
import { ResourceType } from "../../../Core/Api/Types/cockpit-ressource-type";
import { Action } from "../../../Core/Api/Types/cockpit-action";
import { useTranslation } from "react-i18next";

export type ModalJobRetryElementProps = {
  title?: string;
  message?: string;
  jobId: number;
  isCockpit?: boolean;
};

export type ModalJobRetryProps = CommonModalProps<ModalJobRetryElementProps>;

const ModalJobRetry = React.forwardRef<any, ModalJobRetryProps>((props, ref) => {
  const { closeModal, ...modalProps } = props;
  const { message, title, jobId, isCockpit = false } = modalProps;
  const customSnackbar = useCustomSnackbar();
  const { t } = useTranslation();

  const handleConfirmClick = (executeNow: boolean) => {
    isCockpit
      ? cockpitService
          .MakeAdminOperation(
            new MakeOperationRequest({
              resourceId: jobId,
              resourceType: ResourceType.Job,
              action: Action.Retry,
            })
          )
          .then((response) => {
            if (response) customSnackbar(t("alert:success.jobRetry"), "success");
          })
      : jobBrokerService.Retry(jobId, executeNow).then(() => {
          customSnackbar(t("alert:success.jobRetry"), "success");
        });
    closeModal();
  };

  const handleCancelClick = () => {
    closeModal();
  };

  return (
    <Modal title={title} reference={ref} closeModal={handleCancelClick} width={500}>
      <Stack spacing={1}>
        <Typography variant="subtitle2">{message}</Typography>
        <Stack direction="row" justifyContent="flex-end" spacing={1}>
          <Button onClick={() => handleConfirmClick(false)}>{t("common:schedule")}</Button>
          <Button onClick={() => handleConfirmClick(true)}>{t("button:executeNow")}</Button>
        </Stack>
      </Stack>
    </Modal>
  );
});

export default ModalJobRetry;
